// Notificações nativas do sistema operativo para o executável desktop
// (Tauri/WebView2).
//
// Porquê separado de utils/pushNotifications.js: o WebView2 (motor usado
// pelo Tauri no Windows) é baseado em Chromium mas NÃO implementa a Push
// API (PushManager.subscribe() falha sempre — limitação conhecida e antiga
// da Microsoft, não do nosso código). Por isso o mesmo mecanismo de Web
// Push que funciona no telemóvel/browser normal nunca chega ao executável
// desktop. A alternativa aqui é notificação NATIVA do SO, disparada pelo
// próprio processo da app enquanto está aberta (mesmo minimizada) — não é
// push real com a app fechada (isso exigiria integração com o Windows
// Push Notification Service, empacotamento MSIX e certificado —
// deliberadamente fora do âmbito desta implementação).
//
// Import dinâmico do plugin em todas as funções: o pacote
// "@tauri-apps/plugin-notification" só existe dentro do runtime Tauri —
// importar estaticamente rebentaria o bundle web/mobile (que nunca corre
// dentro do Tauri) ao tentar resolver um módulo que só faz sentido lá.

export function isTauriDesktop() {
  return typeof window !== "undefined" && Boolean(window.__TAURI_INTERNALS__);
}

let permissionGrantedCache = null;

/**
 * Pede a permissão de notificações nativas do SO, uma vez, no arranque da
 * app (ver src/Index.jsx). Ao contrário do Web Push (só por ação explícita
 * do utilizador em Configurações), aqui é seguro pedir automaticamente:
 * é o comportamento padrão esperado de qualquer app desktop Windows, e só
 * corre dentro do runtime Tauri — nunca afeta web/mobile.
 */
export async function ensureDesktopNotificationPermission() {
  if (!isTauriDesktop()) return false;

  try {
    const { isPermissionGranted, requestPermission } = await import("@tauri-apps/plugin-notification");
    let granted = await isPermissionGranted();
    if (!granted) {
      const permission = await requestPermission();
      granted = permission === "granted";
    }
    permissionGrantedCache = granted;
    return granted;
  } catch (error) {
    return false;
  }
}

/**
 * Mostra uma notificação nativa do SO (Central de Notificações do
 * Windows). Nunca lança — falhas aqui nunca devem interromper o fluxo que
 * a chamou (mesmo racional do resto da funcionalidade de notificações
 * neste projeto).
 */
export async function sendDesktopNotification({ title, body } = {}) {
  if (!isTauriDesktop()) return false;

  try {
    const { isPermissionGranted, sendNotification } = await import("@tauri-apps/plugin-notification");
    const granted = permissionGrantedCache === true ? true : await isPermissionGranted();
    if (!granted) return false;

    sendNotification({ title: title || "Dissa Ax ERP", body: body || "" });
    return true;
  } catch (error) {
    return false;
  }
}
